<template>
  <div id="certificateTicket">
    <div class="title">
        <p>
            <span class="routerName">合格证制作</span>
            <span>&nbsp;&nbsp;/&nbsp;&nbsp;</span>
            <span class="planName">{{currentPlan.name}}</span>
            <el-dropdown trigger="click" style="margin-left: 8px;">
                <span class="el-dropdown-link">
                <img :src="planImg" alt="">
                </span>
                <template #dropdown>
                <el-dropdown-menu style="max-height:600px;height:auto;overflow-y:auto;">
                    <el-dropdown-item v-for="(item, index) in planList" :key="index" @click.native="changPlan(item)">{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
                </template>
            </el-dropdown>
            <el-button class="changeDialog" size="mini" type="primary" round plain @click="templateDialogOpen">合格证标签</el-button>
            <el-button class="changeDialog" size="mini" type="primary" round @click="submitChange">确认修改</el-button>
        </p>
    </div>
    <div class="Main" :style="{width: templateWidth + 'px', height: templateHeight + 'px', background: `url(${templateBackground})`}" v-if="templateFlag">
        <vue-draggable-resizable
          :resizable="false"
          @dragstop="(left, top)=>onDragstop(item, left, top)"
          v-for="(item, index) in ticketInfo"
          :key="index"
          :grid="[4, 4]"
          :x="item.x"
          :y="item.y"
          :w="item.width"
          :h="item.height"
          :parent="true"
          :active="false"
        >
          <p style="font-weight: 700;" :style="{'font-size': templateFontSize + 'px', 'line-height': templateFontSize + 'px'}" class="noUser">{{item.displayName}}</p>
        </vue-draggable-resizable>
    </div>
    <ots-custom-dialog
      :dialog.sync="templateDialog"
      title="标签选择"
      width="640px"
    >
      <template v-slot:content>
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="baseInfoChoose" @change="handleCheckedCitiesChange">
          <el-checkbox v-for="(item, index) in baseInfo" :label="item" :key="index" style="min-width: 108px;">{{item.displayName}}</el-checkbox>
        </el-checkbox-group>
      </template>
      <template v-slot:footer>
        <el-button round @click="templateDialog = false">取消</el-button>
        <el-button round type="primary" @click="submitTemplate">确定</el-button>
      </template>
    </ots-custom-dialog>
  </div>
</template>
<script>
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import { getSelectPlanFn } from '@/http/modules/examSet/examBatch'

export default {
  components: {
    VueDraggableResizable
  },
  data() {
    return {
      currentPlan: '',
      planImg: require('@/assets/img/courseChange.png'),
      planList: [],
      ticketInfo: [],
      templateWidth: '',
      templateHeight: '',
      templateBackground: '',
      templateFontSize: '',
      originalData: [],
      baseInfo: [],
      templateDialog: false,
      checkAll: false,
      baseInfoChoose: [],
      isIndeterminate: true,
      templateFlag: true,
      QRSize: '',
    }
  },
  async mounted() {
    await this.initData();
    await this.getTemplate();
  },
  methods: {
    // 批次切换
    changPlan(value){
      this.currentPlan = value;
      this.getTemplate();
    },
    // 初始化数据
    async initData(){
      const {data} = await getSelectPlanFn({needAudit: 19});
      this.planList = data;
      this.currentPlan = data[0];
    },
    // 合格证模板信息
    async getTemplate() {
      let planId = this.currentPlan.id;
      const { data } = await this.$api.system.getCertificateTemplate({planId});
      this.templateWidth = data.width;
      this.templateHeight = data.height;
      this.templateBackground = data.url;
      await this.getProperty();
    },
    // 模板全量元素
    async getProperty() {
      const { data } = await this.$api.system.getCertificateProperty();
      // 原始数据
      this.originalData = [...data];
      // 从原始数据中读取元数据
      this.originalData.map(e=> {
        if (e.name == 'fontSize') {
          this.templateFontSize = e.value;
        }
        if (e.name == 'certificateQrImgSize') {
          this.QRSize = e.value;
        }
      })
      let baseInfo = [];
      let heightArr = ['certificateQrImgSize', 'fontSize', 'fontFamily'];
      this.originalData.map(e=> {
        if (heightArr.indexOf(e.name) == -1) {
          baseInfo.push(e);
        }
      })
      // 勾选标签对比用（全量）
      this.baseInfo = baseInfo;
      // 勾选标签的绑定数据（有值的才勾选）
      this.baseInfoChoose = baseInfo.filter(item => item.value);
      // 根据勾选的标签去绘制图形
      this.drawDom(this.baseInfoChoose);
    },

    // 标签绘制
    drawDom(data) {
      let newData = JSON.parse(JSON.stringify(data));
      let ticketInfo = [];
      // 元数据字段，不参与绘制
      let heightArr = ['certificateQrImgSize', 'fontSize', 'fontFamily'];

      // 解析坐标，绘制标签
      newData.map(e=>{
        if (e.value && typeof(e.value) == 'string' && heightArr.indexOf(e.name) == -1) {
          let v = e.value.split(",");
          if (v.length < 3) {
            let xy = e.value.split(",");
            e.x = Number(xy[0]);
            e.y = this.templateHeight - Number(xy[1]) - this.templateFontSize;
            e.width = 120;
            e.height = this.templateFontSize;
            ticketInfo.push(e);
          }
        }
      })

      // 修改 二维码 宽高
      ticketInfo.map(e=>{
        if (e.name == 'certificateQrImgPosition') {
          e.width = Number(this.QRSize.split(",")[0]);
          e.height = Number(this.QRSize.split(",")[1]);
          let xy = e.value.split(",");
          e.x = Number(xy[0]);
          e.y = this.templateHeight - Number(xy[1]) - e.height;
        }
      })
      this.ticketInfo = ticketInfo;
      this.templateFlag = true;
    },
    onDragstop(item, x , y){
      item.x = x
      item.y = y
    },
    submitTemplate() {
      this.templateFlag = false;
      this.baseInfoChoose.map(e=>{
        if (!e.value) {
          e.value = `100, ${this.templateHeight - 60}`;
        }
      })
      this.$nextTick(() => {
        this.drawDom(this.baseInfoChoose);
      })
      this.templateDialog = false;
    },
    templateDialogOpen() {
      this.templateDialog = true;
    },
    // 全选
    handleCheckAllChange(val) {
      this.baseInfoChoose = val ? this.baseInfo : [];
      this.isIndeterminate = false;
    },
    // 勾选
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.baseInfo.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.baseInfo.length;
    },
    // 确认修改
    async submitChange() {
      let submitData = [];
      let position = {};
      // (1) 元数据原样保留
      this.originalData.map((e,i) => {
        if (!e.value || typeof(e.value) != 'string' || e.name == 'certificateQrImgSize' || e.name == 'fontSize' || e.name == 'fontFamily') {
          submitData.push(e);
        }
      })
      // (2) 标签坐标处理
      this.ticketInfo.map(e => {
        let value = [e.x, this.templateHeight - e.y - e.height].join(",");
        let item = {
          displayName: e.displayName,
          name: e.name,
          value
        }
        submitData.push(item);
      })

      submitData.map(s => {
        position[s.name] = s.value;
      })

      //position.pdfWidth = this.templateWidth;

      let params = {
        position: JSON.stringify(position)
      }

      const { code } = await this.$api.system.saveCertificatePrintPosition(params);
      if (code == 1) {
        this.$message.success("修改成功！");
      }
    }
  }
}
</script>

<style scoped lang="less">
#certificateTicket {
  .title {
    height: 32px;
    p {
      display: flex;
      align-items: center;
        .routerName {
            font-size: 14px;
            color: #9299A6;
        }
        .planName {
            font-size: 24px;
            font-weight: 500;
            color: #2D2F33;
        }
        .el-dropdown-link {
            cursor: pointer;
            color: var(--el-color-primary);
            display: flex;
            align-items: center;
        }
    }
    .changeDialog {
      margin-left: 24px;
    }
  }
  .Main {
    position: relative;
    margin-top: 16px;
    border: 2px dashed #2D2F33;
    border-radius: 8px;
    box-sizing: border-box;
  }
  .noUser {
    user-select: none;
  }
}
</style>
